// extracted by mini-css-extract-plugin
export var form = "_ef-0";